import React from "react";
import { faCommentDots } from "@fortawesome/free-regular-svg-icons";
import {
  faFileLines,
  faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import { Button } from "./components/Button";
import { Card } from "./components/Card";
import { Header } from "./components/Header";
import { Section } from "./components/Section";
import "./ResponsiveLandingPage.css";
import { Footer } from "./components/Footer";

export function ResponsiveLandingPage() {
  return (
    <div className="newLandingPage">
      <Header />
      <div className="alignText">
        <div className="fullWithContent">
          <Section />
          <div className="contentCard">
            <Card type="Paciente" />
            <Card type="Profissional" />
          </div>
          <div className="buttons">
            <Button
              icon={faFileLines}
              type="terms"
              text="Termo de uso e aviso de privacidade"
            />
            <Button
              icon={faQuestionCircle}
              text="Perguntas frequentes"
              type="questions"
            />
            <Button
              icon={faCommentDots}
              text="Fale com a HU Brasil"
              type="faq"
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
